import React, { forwardRef } from 'react';
import { useId } from '@reach/auto-id';

import { Label } from '../label.component';
import { CheckboxRadioInput } from './checkbox-radio-input.component';

type LabeledCheckboxRadioInputOwnProps = {
  label?: string;
  helpText?: string;
};

export type LabeledCheckboxRadioInputProps = React.ComponentPropsWithRef<
  typeof CheckboxRadioInput
> &
  LabeledCheckboxRadioInputOwnProps;

export const LabeledCheckboxRadioInput = forwardRef<
  HTMLInputElement,
  LabeledCheckboxRadioInputProps
>(function LabeledCheckboxRadioInput(
  { label, helpText, id, hasError, disabled, className, ...rest },
  ref
) {
  const inputId = useId(id);
  const helpTextId = useId();

  return (
    <div className={className}>
      <div className="flex items-center">
        <CheckboxRadioInput
          id={inputId}
          hasError={hasError}
          disabled={disabled}
          ref={ref}
          aria-describedby={helpText ? helpTextId : undefined}
          {...rest}
        />

        <Label
          htmlFor={inputId}
          hasError={hasError}
          bold={false}
          variant={disabled ? 'disabled' : 'default'}
          className="ml-2"
        >
          {label}
        </Label>
      </div>
      {helpText && (
        <div className="text-xs text-gray-400 ml-6" id={helpTextId}>
          {helpText}
        </div>
      )}
    </div>
  );
});
